let variantId = "";
$(document).on("click", ".product-color", function(){
    let color = $(this).find('span').text();
    $("#ProductSelect-product-template option").each(function(){
      if($(this).text().trim().indexOf(color) != -1){
        variantId = $(this).val();
      }
    })
    if($("#storeDispnible").attr("data-has-only-default-variant")){
      storeAvailability(variantId);
    }
}) 

if($("#storeDispnible").attr("data-has-only-default-variant")){
      storeAvailability($("#ProductSelect-product-template").val());
}

function storeAvailability(variantId){
  $("#shopify-section-store-availability").remove();
  fetch(window.Shopify.routes.root + "variants/"+variantId+"/?section_id=store-availability")
  .then(response => response.text())
  .then(text => {
      let ciudades = [];
      let tiendas = [];
      const container = document.querySelector('[data-store-availability-container]');
      const pickupAvailabilityHTML = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.shopify-section');
         
         $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
          	if(!ciudades.includes("LIMA") && $(this).html().includes("PE-LMA")){
                ciudades.push("LIMA");
                $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                  if(!tiendas.includes(tiendas[i]) && $(this).html().includes("PE-LMA")){
                    tiendas.push({tienda: "LIMA", content: $(this).parent().html()});
                  }
                })
              }
          })
          container.appendChild(pickupAvailabilityHTML);
          updateProductCiudades(ciudades, tiendas);
  })
  .catch(e => {
      console.error(e);
  });  
}

function updateProductCiudades(ciudades, tiendas){
      for(var i = 0; i < ciudades.length; i++){
        $(".container-ciudades").append("<div class='item-list-tiendas'><span>"+ciudades[i]+"</span><div class='container-tiendas-product container-tiendas-product-"+ciudades[i]+"'></div></div>");
        for(var j = 0; j < tiendas.length; j++){
          if(tiendas[j].tienda == ciudades[i]){
          	$(".container-tiendas-product-"+ciudades[i]).append(tiendas[j].content);
          }
        }
      }
      $(".container-ciudades .item-list-tiendas").click(function(){
        if($(this).find('.container-tiendas-product').is(":visible")){
            $('.container-tiendas-product').attr("style", "display: none;");
        	$(this).find('.container-tiendas-product').attr("style", "display: none;")
        }else{
            $('.container-tiendas-product').attr("style", "display: none;");
          	$(this).find('.container-tiendas-product').attr("style", "display: block; animation: zoomAnimation2 2s")
        }
        
      })
}

$(document).on("click", ".store-availability-information", function(){
  if($("#StoreAvailabilityModal").is(":visible")){
    $("#StoreAvailabilityModal").attr("style", "display: none");  
  }else{
    $("#StoreAvailabilityModal").attr("style", "display: flex");
    $("#imageProduct").attr('src', $("#storeDispnible").attr("data-product-image"));
  }
})

$(document).on("click", "#closeModalStoreAvailability", function(){
   $("#StoreAvailabilityModal").attr("style", "display: none");  
});

$("#StoreAvailabilityModal").click(function() {
   $(this).attr("style", "display: none");
});

$(document).on("click", ".content-store-availability", function(event){
    event.stopPropagation();
});

$(document).on("click", '#closeModalStoreAvailability', function(event){
    event.stopPropagation();
});

$(document).on("click", "#add-cart-store-avaible", function(){
    addProductStoreAvailability($(this).attr("data-id-product-variant"));
});

function addProductStoreAvailability (idVariant){
    let formData = {
      'items': [{
      	'id': parseInt(idVariant),
      	'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
    })
    .then(response => {
       $(this).text("Agregado!").css("background","black");
       location.href = "/cart";
       
	})
    .catch((error) => {
       console.error('Error:', error);
    });
};
